import script from "./CalendarMonth.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarMonth.vue?vue&type=script&setup=true&lang=js"

import "./CalendarMonth.vue?vue&type=style&index=0&id=3f9f9a90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9f9a90"]])

export default __exports__